<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-folder"></i> Documents
      <label
        class="switch switch-sm switch-text switch-success float-right mb-0 ml-1"
        v-if="hasPermission($store.state.user, 'USERS_WRITE')"
      >
        <input
          type="checkbox"
          class="switch-input"
          v-model="disbursement"
          @click="handleDisbursement"
        />
        <span class="switch-label" data-on="On" data-off="Off"></span>
        <span class="switch-handle"></span>
      </label>
      <button
        class="btn btn-success btn-sm float-right"
        @click="handleDisbursement(true)"
        v-if="!disbursement && hasPermission($store.state.user, 'USERS_WRITE')"
      >
        <i class="fa fa-check-circle"></i> Valider
      </button>
      <button
        class="btn btn-primary btn-sm float-right mr-1"
        @click="openImportModal"
        v-if="hasPermission($store.state.user, 'DOCUMENTS_WRITE')"
      >
        <i class="fa fa-upload"></i> Importer
      </button>
    </div>

    <div class="card-block">
      <el-table :data="documents" :show-header="false">
        <el-table-column>
          <template slot-scope="scope">
            <a
              @click="
                downloadSecuredFile(`uploads/document/${scope.row.fileId}`)
              "
              >{{ scope.row.name || scope.row.tag }}
            </a>
            <div class="text-muted">
              {{ scope.row.tag }}
            </div>
            <div v-if="scope.row.updatedAt" class="badge badge-warning">
              Mis à jour le {{ formatDate(scope.row.updatedAt) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.validatedAt">
              <i class="fa fa-check text-success text-center"></i> Validé le
              <br />
              {{ formatDate(scope.row.validatedAt) }}
            </template>

            <template v-else>
              <button
                class="btn btn-sm btn-success"
                @click="validDocument(scope.row)"
                v-if="hasPermission($store.state.user, 'DOCUMENTS_WRITE')"
              >
                <i class="fa fa-check"></i>
                Valider
              </button>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          v-if="hasPermission($store.state.user, 'DOCUMENTS_WRITE')"
          width="40"
          align="right"
        >
          <template slot-scope="scope">
            <button
              class="btn btn-sm btn-danger"
              @click="removeDocument(scope.row.fileId, scope.$index)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <modal
      title="Importer un document"
      v-model="importModalOpen"
      @cancel="closeImportModal"
      effect="fade/zoom"
    >
      <div class="form-group">
        <label>Type de document <span class="text-danger">*</span></label>
        <el-select
          v-model="importForm.tag"
          placeholder="Sélectionner un type"
          style="width: 100%"
        >
          <el-option
            v-for="tag in tagOptions"
            :key="tag"
            :label="tag"
            :value="tag"
          />
        </el-select>
      </div>

      <div class="form-group" v-if="importForm.tag">
        <dropzone
          :id="`doc-import-${coach.id}`"
          ref="importDropzone"
          :url="apiUploads()"
          :headers="apiAuthorization()"
          :thumbnailHeight="80"
          :thumbnailWidth="180"
          :maxFiles="1"
          @vdropzone-success="onFileUploaded"
          @vdropzone-removed-file="onFileRemoved"
          @vdropzone-sending="addFolderParam"
        >
          <div class="dz-default dz-message">
            <span
              ><i class="icon-cloud-upload"></i><br />Glissez le document
              ici</span
            >
          </div>
        </dropzone>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button class="btn btn-secondary" @click="closeImportModal">
          Annuler
        </button>
        <button
          class="btn btn-primary"
          @click="submitImport"
          :disabled="!importForm.tag || !importForm.fileId || importing"
        >
          <i class="fa fa-spinner fa-spin" v-if="importing"></i>
          Enregistrer
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import Dropzone from "vue2-dropzone";
import Modal from "vue-strap/src/Modal";
import DownloadFile from "@/mixin/DownloadFile";

export default {
  components: {
    Dropzone,
    Modal,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  mixins: [DownloadFile],
  data() {
    return {
      documents: [],
      disbursement: false,
      importModalOpen: false,
      importing: false,
      importForm: {
        tag: null,
        fileId: null,
        fileName: null,
      },
      documentTags: [],
    };
  },
  computed: {
    tagOptions() {
      const usedTags = (this.documents || []).map((d) => d.tag);

      return this.documentTags.filter((tag) => !usedTags.includes(tag));
    },
  },
  mounted() {
    this.documents = this.coach.documents;
    this.disbursement = this.coach.disbursement;

    this.loadDocumentTags();
  },
  methods: {
    async loadDocumentTags() {
      try {
        const { data } = await this.$api.get("/users/coachs/documents/tags");

        this.documentTags = data || [];
      } catch {
        this.documentTags = [];
      }
    },

    apiUploads() {
      return `${axios.defaults.baseURL}uploads`;
    },

    apiAuthorization() {
      return { Authorization: localStorage.getItem("token") };
    },

    openImportModal() {
      this.importForm = { tag: null, fileId: null, fileName: null };
      this.importModalOpen = true;
    },

    closeImportModal() {
      if (this.importForm.fileId && this.$refs.importDropzone) {
        this.$refs.importDropzone.removeAllFiles(true);
      }

      this.importForm = { tag: null, fileId: null, fileName: null };
      this.importModalOpen = false;
    },

    onFileUploaded(_, response) {
      this.importForm.fileId = response.id;
      this.importForm.fileName = response.name;
    },

    onFileRemoved() {
      this.importForm.fileId = null;
      this.importForm.fileName = null;
    },

    addFolderParam(_file, _xhr, formData) {
      formData.append("folder", "users");
    },

    async submitImport() {
      if (!this.importForm.tag || !this.importForm.fileId) return;

      this.importing = true;

      try {
        await this.$api.post("/users/coachs/documents", {
          email: this.coach.email,
          fileId: this.importForm.fileId,
          name: this.importForm.fileName || this.importForm.tag,
          tag: this.importForm.tag,
        });

        this.documents = this.documents || [];
        this.documents.push({
          fileId: this.importForm.fileId,
          name: this.importForm.fileName || this.importForm.tag,
          tag: this.importForm.tag,
          createdAt: new Date().toISOString(),
        });

        this.closeImportModal();
      } catch (e) {
        this.$toast.error(
          e?.response?.status === 409
            ? "Un document de ce type existe déjà."
            : "Erreur lors de l'import du document.",
        );
      } finally {
        this.importing = false;
      }
    },

    handleDisbursement(event) {
      if (typeof event === "boolean") {
        this.disbursement = event;
      }

      this.$api.put("/users", {
        email: this.coach.email,
        disbursement:
          typeof event === "boolean" ? event : event.target?.checked,
      });
    },
    validDocument(doc) {
      this.$confirm({
        message: "Valider le document ?",
        onConfirm: async () => {
          await this.$api.patch(`/users/coachs/document/${doc.fileId}`, {
            email: this.coach.email,
          });

          this.documents = this.documents.map((d) => {
            if (d.fileId === doc.fileId) {
              return {
                ...d,
                validatedAt: new Date().toISOString(),
              };
            }

            return d;
          });

          if (
            this.documents.find((d) => d.fileId === doc.fileId)?.tag ===
              "Contrat" &&
            !this.disbursement &&
            this.coach.coach.disbursementOnBeforeNewContract
          ) {
            this.disbursement = true;
          }
        },
      });
    },
    removeDocument(fileId, index) {
      this.$confirm({
        message: "Supprimer le document ?",
        onConfirm: async () => {
          await this.$api.delete(`/users/coachs/document/${fileId}`, {
            data: {
              email: this.coach.email,
            },
          });

          this.documents.splice(index, 1);
        },
      });
    },
  },
};
</script>
